<template>
  <div class="ml-1">
    <base-button
      :variant="'pure'"
      className="v-btn v-btn--icon v-theme--BLUE_THEME v-btn--density-default v-btn--size-default v-btn--variant-text custom-hover-primary"
      style="position: relative;"
      aria-haspopup="menu"
      aria-expanded="false"
      aria-owns="v-menu-669"
    >
      <div
        class="v-avatar v-avatar--density-default v-avatar--variant-flat"
        style="width: 35px; height: 35px"
      >
        <img
          src="data:image/jpeg;base64,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"
          width="35"
          alt="Julia"
          @click="openUserModal"
          v-if="user?.avatar"
        />
        <div v-else class="circle" @click="openUserModal">{{userAltText}}</div>        
        <span class="v-avatar__underlay"></span>
      </div>
    </base-button>
  </div>
  <base-modal
    v-model="showUserModal"
    :input-event="userModalEvent"
    content-width="360px"
    content-height="300px"
    position="left"
    offsetLeft="30"
  >
    <div class="px-8 pt-6">
      <h6 class="text-h5 font-weight-medium">
        {{ $t("account.profileDetails") }}
      </h6>
      <div class="d-flex align-center mt-4 pb-6">
        <div
          class="v-avatar v-avatar--density-default v-avatar--variant-flat"
          style="width: 80px; height: 80px"
        >
          <img
            src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD//gAfQ29tcHJlc3NlZCBieSBqcGVnLXJlY29tcHJlc3P/2wCEAAQEBAQEBAQEBAQGBgUGBggHBwcHCAwJCQkJCQwTDA4MDA4MExEUEA8QFBEeFxUVFx4iHRsdIiolJSo0MjRERFwBBAQEBAQEBAQEBAYGBQYGCAcHBwcIDAkJCQkJDBMMDgwMDgwTERQQDxAUER4XFRUXHiIdGx0iKiUlKjQyNEREXP/CABEIAGQAZAMBIgACEQEDEQH/xAAdAAABBAMBAQAAAAAAAAAAAAAAAQIFBgMHCAQJ/9oACAEBAAAAAOJwAAAAAAABBT0dLzfNNcQRWjvR9BOiY7TPLumYlEB2/wDvePruoKxV+aRoO73ucbNR+sYDkpEF6n3jqus7rteuZ757MRH2u6SWzds8k7o93HcUAzoOgTUnddaVSqNGma8UsHsMeMaZsqo0VuJoxXO9DsariwOTG5W+xzUTA1yf/8QAGQEBAAMBAQAAAAAAAAAAAAAAAAEDBAIF/9oACAECEAAAALgCrPfcZ8OPT7KPKz0avaln657sEEzCCX//xAAZAQACAwEAAAAAAAAAAAAAAAAAAgEEBQP/2gAIAQMQAAAAqgAMdLVeudO2hqZ+HD6ty1n4at2GTjDMQQjjRBH/xAA4EAACAQMDAgIJAgMJAQAAAAABAgMEBREABhIhMSJBBxATFCAyUWGBCBZCUnEVIyQlM0BDYpHB/9oACAEBAAE/AP8AdZ1n10tJU11TBR0VPJPUzOEiiiUu7sewUDW0/wBNF8uVNDXbpuAt6uOQpIAJJwP+7HoDrcP6f7Ba6Caphrp4liXk088vQAavu3aizz4CzNA3yPJEYiw8jg9cHRBUkMCD9D68/DSUtRXVMNJSxmSaVgqKO5J16HPRRb9oUEVxq4UnvdQmZZ2H+mh/40+i6jhVIy0gwoH5Oqq0w12ZaqNSg+VW7dOx1v3blrrYTQ0dPC9ZI3ilZA4iHm+DkE+Sg6o9jRXyvvG2Lq/+bUTOIK1ejSA+NS/1BGr3Za7b9yqbXcYTHUQtgg+Y8j8foO2jNdr1DdJIx7nAeUjH+NuyRD7D53/A1DXUltiCvIowO7HA028IHmdIKeacrnxceKDH9dVe4r/dxUewKU9IuQgj8U0hH3PRV1Yn3bdt0yUc1RdaGCNWlmWogianfiwHANjryz5atNZK3pau8NdBFEYlEDhDlgFyEd/uQNfqEtUUlRaNxwKAzD3Kqx/Og5I35Hx+hanZthWuenpjHNKvFnI8oT7MN+cau9bFRM1ROWnclI4UB5SzzueKRxj7nW7a6rgoINtWepp4LlU4SsmSVTJFkBn4L38++rXF/ZsEMKE8I41UZ69ANSbpgFdWCN4ozSDDiXK8mI6dQOi/fSy/ujeNNfaegp4JY4pKaskppfaCZEbCMxH5A16Z4H/b0vJyMSLLxP8AGo8P/qkj4VUsyqoySQAPudbC2HthoIzuCzRV0x45Lo8UQb6B8oG1dt3WLatoSmJp6WlgRYoKOlGAcdFTp3/oNV+9RZ4P3peoZXu1THItkoQBxhj7PVvnoCflQ69FddW7ordx3eqYe+viWJzluPMnpk9TqHcnsyILlC0DgYZu6E6Suo5qUrSVoVzH0ZGww1sW8m3bg3FaK6NJ456tpRMAuDlQcjiOme5GvS1Y7ffNi1/uytK0RWRfZDlInXuAO4GnQxu0bDqpIOj60YK6OQDxYHB7HB0m9twR1M08dynUPnpy5cc/TOtmUs91qjetwVUtRFAhkLSPnhH9FB/ifsPprfVfW3WnFXNDxqbjxhpIAOIipYhxUAHsoHX8nXoapKSjtlAqyAVoeanrIT0kjcOWCuNblWkhpZUFMZahxhFQeIk6mTcN5ut1ShuNQkdMZjGF+Q+74En4ySAdbJ23LUUNJdKGdpWeAMU5EP7RiQwLeYz1Otx3m97OttPXXoRoDLLG2G8LKxATIHXI6nV8r4bpd7jcKeD2MU87OieYXyzjzPc/CFZjga2XIk9BRp7pH/ezpS0lJy5e8VXQuznyhhBDP+BreG6Za/eE10t8yvTUL+70fIZWSOLKlyBjPtCSx1Tbi21XyQzStNb6oK8acuYCsSDGRUQEOkSDw4IYjVdfLHIkC1O86yriZEVy09bMVYheamImPKr1wS3i1tLdtjodvSXM0KQUk9fFY0hldDP7vNyknIKheiqQEHkdfum6bDucsu0t2pVU7yyf4UwyDgv8s8coAVh9FOtybw3Hu2p95vlxaTChVhj8EKgHPyjTLj4VGCDnUG7norPBQW2kEFWkE9M1UX5ERTnL8B5M+eJP01jX/wA0NGWTikftG4A8guegYjBIH1ONMxZi7ElmOSx7k6PRTpuo+AeWh8H09ZzjGh20e+s6z9xoHRPh0JhkBRnQOdY++j09cjEKSNBgqjR6gH1r56btqDu2l0fVnWTg6kY8W1GoKgnRJ5H7aOv/xAAiEQEAAgIBBAIDAAAAAAAAAAABAgMAERIEICExEFETMDL/2gAIAQIBAT8A/QoG3OXL06MsnOjc2W4/TlV0bTx4ezqJsYgHtyXUSjFlvUTGxs1KyUl+s6a/jYRB4qG/l9OsthdXFlbb4yYPT/z7mGQjZFltNB5conMAIcvOCoKadfN9RZxE3pz8UOJHXrGiCJka4R08TfY9xn33f//EACMRAAICAQQCAgMAAAAAAAAAAAECAxEABBAhMRIgEzJRgcH/2gAIAQMBAT8A96yrwIF7GRRpqCIwlN+Rk+naFqPI9NOgZzZqhkelV2VACS36AGJD4eSQRqRXdc5rdMSGZjTgEkbVtC8EjhIoucibx1H26Qkj+Y8kZCFQbJ4GapVZnLPRxgLIBsZxtDI0RYq1WM+V/ItfeDUPYOGR2seRrCM49j1sMPoetv/Z"
            width="80"
            v-if="user?.avatar"
          />
          <div v-else class="circle-full" @click="openUserModal">{{userAltText}}</div>
          <!---->
          <span class="v-avatar__underlay"></span>
        </div>
        <div class="ml-3">
          <h6 class="text-h6 mb-n1">{{ user?.full_name }}</h6>
          <span class="text-subtitle-1 font-weight-regular textSecondary"
            >Programer</span
          >
          <div class="d-flex align-center mt-1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-mail"
              width="18px"
              height="18px"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <rect x="3" y="5" width="18" height="14" rx="2"></rect>
              <polyline points="3 7 12 13 21 7"></polyline></svg
            ><span
              class="text-subtitle-1 font-weight-regular textSecondary ml-2"
              >{{ user?.email }}</span
            >
          </div>
        </div>
      </div>
      <hr
        class="v-divider v-theme--BLUE_THEME"
        aria-orientation="horizontal"
        role="separator"
      />
    </div>
    <div class="ps" style="height: calc(100vh - 240px); max-height: 240px">
      <div
        class="v-list v-theme--BLUE_THEME v-list--density-default v-list--two-line py-0 theme-list"
        role="listbox"
      >
        <a
          class="v-list-item v-list-item--link v-theme--BLUE_THEME v-list-item--density-default v-list-item--two-line v-list-item--variant-text py-4 px-8 custom-text-primary"
          href="/apps/profile"
          tabindex="0"
          style="min-height: 45px"
          ><span class="v-list-item__overlay"></span
          ><span class="v-list-item__underlay"></span>
          <div class="v-list-item__prepend">
            <div
              class="v-avatar bg-lightprimary v-avatar--density-default rounded-md v-avatar--variant-flat mr-3"
              style="width: 48px; height: 48px"
            >
              <div
                class="v-responsive v-img"
                aria-label="@/assets/icons/icon-account.svg"
                role="img"
                style="height: 24px; width: 24px"
              >
                <div
                  class="v-responsive__sizer"
                  style="padding-bottom: 100%"
                ></div>
                <img
                  class="v-img__img v-img__img--contain"
                  src="@/assets/icons/icon-account.svg"
                  alt=""
                  style=""
                />
              </div>
              <span class="v-avatar__underlay"></span>
            </div>
          </div>
          <div class="v-list-item__content">
            <div>
              <h6
                class="text-subtitle-1 font-weight-semibold mb-1 custom-title"
              >
                {{ $t("account.profile") }}
              </h6>
            </div>
            <p class="text-subtitle-1 font-weight-regular text-medium-emphasis">
              {{ $t("account.accountSettings") }}
            </p>
          </div> </a
        ><a
          class="v-list-item v-list-item--link v-theme--BLUE_THEME v-list-item--density-default v-list-item--two-line v-list-item--variant-text py-4 px-8 custom-text-primary"
          href="/apps/inbox"
          tabindex="0"
          style="min-height: 45px"
          ><span class="v-list-item__overlay"></span
          ><span class="v-list-item__underlay"></span>
          <div class="v-list-item__prepend">
            <div
              class="v-avatar bg-lightprimary v-avatar--density-default rounded-md v-avatar--variant-flat mr-3"
              style="width: 48px; height: 48px"
            >
              <div
                class="v-responsive v-img"
                aria-label="@/assets/icons/icon-inbox.svg"
                role="img"
                style="height: 24px; width: 24px"
              >
                <div
                  class="v-responsive__sizer"
                  style="padding-bottom: 100%"
                ></div>
                <img
                  class="v-img__img v-img__img--contain"
                  src="@/assets/icons/icon-inbox.svg"
                  alt=""
                  style=""
                />
              </div>
              <span class="v-avatar__underlay"></span>
            </div>
          </div>
          <div class="v-list-item__content">
            <div>
              <h6
                class="text-subtitle-1 font-weight-semibold mb-1 custom-title"
              >
                My Inbox
              </h6>
            </div>
            <p class="text-subtitle-1 font-weight-regular text-medium-emphasis">
              Messages &amp; Emails
            </p>
          </div>
        </a>
      </div>
      <div class="ps__rail-x" style="left: 0px; bottom: 0px">
        <div
          class="ps__thumb-x"
          tabindex="0"
          style="left: 0px; width: 0px"
        ></div>
      </div>
      <div class="ps__rail-y" style="top: 0px; right: 0px">
        <div
          class="ps__thumb-y"
          tabindex="0"
          style="top: 0px; height: 0px"
        ></div>
      </div>
    </div>

    <div class="pt-4 pb-6 px-8 text-center">
      <base-button
        :variant="'pure'"
        className="v-btn v-btn--block v-theme--BLUE_THEME text-primary v-btn--density-default v-btn--size-default v-btn--variant-outlined"
        @click="logout"
      >
        {{ $t("buttons.loguot") }}
      </base-button>
    </div>
  </base-modal>
</template>
<script>
import BaseButton from "@/components/BaseButton.vue";
import BaseModal from "@/components/BaseModal.vue";
import { mapState, mapActions } from "pinia";
import { useUserStore } from "@/stores/userStore";

export default {
  name: "HeaderUserMenu",
  props: {},
  components: { BaseButton, BaseModal },
  data() {
    return {
      showUserModal: false,
      userModalEvent: null,
    };
  },
  computed: {
    ...mapState(useUserStore, ["user"]),
    userAltText(){
      if (this.user?.full_name?.length > 0){
        return this.user?.full_name[0];
      }
      else return 'X'
    }
  },
  methods: {
    ...mapActions(useUserStore, ["logout"]),
    openUserModal(event) {
      this.userModalEvent = event;
      this.showUserModal = true;
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 15px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  background: #2a9fd8;
}
.circle-full {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  font-size: 40px;
  color: #fff;
  line-height: 70px;
  text-align: center;
  background: #2a9fd8;
}
</style>
